import React, { useState, useMemo, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { apiClient } from '../../../components/api/ApiClient';

const PROVINCE_CITY_DATA = [
    { "province": "اردبیل", "cities": ["اردبیل", "اصلاندوز", "آبی بیگلو", "بیله سوار", "پارس آباد", "تازه کند", "تازه کندانگوت", "جعفرآباد", "خلخال", "رضی", "سرعین", "عنبران", "فخرآباد", "کلور", "کوراییم", "گرمی", "گیوی", "لاهرود", "مرادلو", "مشگین شهر", "نمین", "نیر", "هشتجین", "هیر"] },
    { "province": "اصفهان", "cities": ["ابریشم", "ابوزیدآباد", "اردستان", "اژیه", "اصفهان", "افوس", "انارک", "ایمانشهر", "آران وبیدگل", "بادرود", "باغ بهادران", "بافران", "برزک", "برف انبار", "بوئین ومیاندشت", "بهاران شهر", "بهارستان", "پیربکران", "تودشک", "تیران", "جندق", "جوزدان", "جوشقان وکامو", "چادگان", "چرمهین", "چمگردان", "حبیب آباد", "حسن آباد", "حنا", "خالدآباد", "خمینی شهر", "خوانسار", "خور", "خوراسگان", "خورزوق", "داران", "دامنه", "درچه پیاز", "دستگرد", "دولت آباد", "دهاقان", "دهق", "دیزیچه", "رزوه", "رضوانشهر", "زاینده رود", "زرین شهر", "زواره", "زیباشهر", "سده لنجان", "سفیدشهر", "سگزی", "سمیرم", "شاپورآباد", "شاهین شهر", "شهرضا", "طالخونچه", "عسگران", "علویچه", "فرخی", "فریدونشهر", "فلاورجان", "فولادشهر", "قمصر", "قهجاورستان", "قهدریجان", "کاشان", "کرکوند", "کلیشادوسودرجان", "کمشچه", "کمه", "کوشک", "کوهپایه", "کهریزسنگ", "گرگاب", "گزبرخوار", "گلپایگان", "گلدشت", "گلشن", "گلشهر", "گوگد", "لای بید", "مبارکه", "محمدآباد", "مشکات", "منظریه", "مهاباد", "میمه", "نائین", "نجف آباد", "نصرآباد", "نطنز", "نوش آباد", "نیاسر", "نیک آباد", "ورزنه", "ورنامخواست", "وزوان", "ونک", "هرند"] },
    { "province": "البرز", "cities": ["اشتهارد", "آسارا", "تنکمان", "چهارباغ", "سیف آباد", "شهرجدیدهشتگرد", "طالقان", "کرج", "کمال شهر", "کوهسار", "گرمدره", "ماهدشت", "محمدشهر", "مشکین دشت", "نظرآباد", "هشتگرد"] },
    { "province": "ایلام", "cities": ["ارکواز", "ایلام", "ایوان", "آبدانان", "آسمان آباد", "بدره", "پهله", "توحید", "چوار", "دره شهر", "دلگشا", "دهلران", "زرنه", "سراب باغ", "سرابله", "صالح آباد", "لومار", "مورموری", "موسیان", "مهران", "میمه"] },
    { "province": "آذربایجان شرقی", "cities": ["اسکو", "اهر", "ایلخچی", "آبش احمد", "آذرشهر", "آقکند", "باسمنج", "بخشایش", "بستان آباد", "بناب", "بناب جدید", "تبریز", "ترک", "ترکمانچای", "تسوج", "تیکمه داش", "جلفا", "خاروانا", "خامنه", "خراجو", "خسروشهر", "خمارلو", "خواجه", "دوزدوزان", "زرنق", "زنوز", "سراب", "سردرود", "سیس", "سیه رود", "شبستر", "شربیان", "شرفخانه", "شندآباد", "شهرجدیدسهند", "صوفیان", "عجب شیر", "قره آغاج", "کشکسرای", "کلوانق", "کلیبر", "کوزه کنان", "گوگان", "لیلان", "مراغه", "مرند", "ملکان", "ممقان", "مهربان", "میانه", "نظرکهریزی", "وایقان", "ورزقان", "هادیشهر", "هریس", "هشترود", "هوراند", "یامچی"] },
    { "province": "آذربایجان غربی", "cities": ["ارومیه", "اشنویه", "ایواوغلی", "آواجیق", "باروق", "بازرگان", "بوکان", "پلدشت", "پیرانشهر", "تازه شهر", "تکاب", "چهاربرج", "خلیفان", "خوی", "دیزج دیز", "ربط", "سردشت", "سرو", "سلماس", "سیلوانه", "سیمینه", "سیه چشمه", "شاهین دژ", "شوط", "فیرورق", "قره ضیاءالدین", "قطور", "قوشچی", "کشاورز", "گردکشانه", "ماکو", "محمدیار", "محمودآباد", "مهاباد", "میاندوآب", "میرآباد", "نالوس", "نقده", "نوشین"] },
    { "province": "بوشهر", "cities": ["امام حسن", "انارستان", "اهرم", "آبپخش", "آبدان", "برازجان", "بردخون", "بردستان", "بندردیر", "بندردیلم", "بندرریگ", "بندرکنگان", "بندرگناوه", "بنک", "بوشهر", "تنگ ارم", "جم", "چغادک", "خارک", "خورموج", "دالکی", "دلوار", "ریز", "سعدآباد", "سیراف", "شبانکاره", "شنبه", "عسلویه", "کاکی", "کلمه", "نخل تقی", "وحدتیه"] },
    { "province": "تهران", "cities": ["ارجمند", "اسلامشهر", "اندیشه", "آبسرد", "آبعلی", "باغستان", "باقرشهر", "بومهن", "پاکدشت", "پردیس", "پیشوا", "تجریش", "تهران", "جوادآباد", "چهاردانگه", "حسن آباد", "دماوند", "رباط کریم", "رودهن", "ری", "شاهدشهر", "شریف آباد", "شهریار", "صالح آباد", "صباشهر", "صفادشت", "فردوسیه", "فرون آباد", "فشم", "فیروزکوه", "قدس", "قرچک", "کهریزک", "کیلان", "گلستان", "لواسان", "ملارد", "نسیم شهر", "نصیرآباد", "وحیدیه", "ورامین"] },
    { "province": "چهارمحال وبختیاری", "cities": ["اردل", "آلونی", "باباحیدر", "بروجن", "بلداجی", "بن", "جونقان", "چلگرد", "سامان", "سفیددشت", "سودجان", "سورشجان", "شلمزار", "شهرکرد", "طاقانک", "فارسان", "فرادنبه", "فرخ شهر", "کیان", "گندمان", "گهرو", "لردگان", "مال خلیفه", "ناغان", "نافچ", "نقنه", "هفشجان"] },
    { "province": "خراسان جنوبی", "cities": ["ارسک", "اسدیه", "اسفدن", "اسلامیه", "آرین شهر", "آیسک", "بشرویه", "بیرجند", "حاجی آباد", "خضری دشت بیاض", "خوسف", "زهان", "سرایان", "سربیشه", "سه قلعه", "شوسف", "طبس مسینا", "فردوس", "قائن", "قهستان", "گزیک", "محمد شهر", "مود", "نهبندان", "نیمبلوک"] },
    { "province": "خراسان رضوی", "cities": ["احمدآبادصولت", "انابد", "باجگیران", "باخرز", "بار", "بایگ", "بجستان", "بردسکن", "بیدخت", "تایباد", "تربت جام", "تربت حیدریه", "جغتای", "جنگل", "چاپشلو", "چکنه", "چناران", "خرو", "خلیل آباد", "خواف", "داورزن", "درگز", "درود", "دولت آباد", "رباط سنگ", "رشتخوار", "رضویه", "روداب", "ریوش", "سبزوار", "سرخس", "سفیدسنگ", "سلامی", "سلطان آباد", "سنگان", "شادمهر", "شاندیز", "ششتمد", "شهرآباد", "شهرزو", "صالح آباد", "طرقبه", "عشق آباد", "فرهادگرد", "فریمان", "فیروزه", "فیض آباد", "قاسم آباد", "قدمگاه", "قلندرآباد", "قوچان", "کاخک", "کاریز", "کاشمر", "کدکن", "کلات", "کندر", "گلمکان", "گناباد", "لطف آباد", "مزدآوند", "مشهد", "مشهدریزه", "ملک آباد", "نشتیفان", "نصر آباد", "نقاب", "نوخندان", "نیشابور", "نیل شهر", "همت آباد", "یونسی"] },
    { "province": "خراسان شمالی", "cities": ["اسفراین", "ایور", "آشخانه", "بجنورد", "پیش قلعه", "تیتکانلو", "جاجرم", "حصارگرمخان", "درق", "راز", "سنخواست", "شوقان", "شیروان", "صفی آباد", "فاروج", "قاضی", "گرمه", "لوجلی"] },
    { "province": "خوزستان", "cities": ["اروندکنار", "الوان", "امیدیه", "اندیمشک", "اهواز", "ایذه", "آبادان", "آغاجاری", "باغ ملک", "بستان", "بندرامام خمینی", "بندرماهشهر", "بهبهان", "ترکالکی", "جایزان", "جنت مکان", "چغامیش", "چمران", "چوئبده", "حر", "حسینیه", "حمزه", "حمیدیه", "خرمشهر", "دارخوین", "دزآب", "دزفول", "دهدز", "رامشیر", "رامهرمز", "رفیع", "زهره", "سالند", "سردشت", "سماله", "سوسنگرد", "شادگان", "شاوور", "شرافت", "شوش", "شوشتر", "شیبان", "صالح شهر", "صالح مشطط", "صفی آباد", "صیدون", "قلعه تل", "قلعه خواجه", "گتوند", "گوریه", "لالی", "مسجدسلیمان", "مشراگه", "مقاومت", "ملاثانی", "میانرود", "میداود", "مینوشهر", "ویس", "هفتگل", "هندیجان", "هویزه"] },
    { "province": "زنجان", "cities": ["ابهر", "ارمغانخانه", "آب بر", "چورزق", "حلب", "خرمدره", "دندی", "زرین آباد", "زرین رود", "زنجان", "سجاس", "سلطانیه", "سهرورد", "صائین قلعه", "قیدار", "گرماب", "ماه نشان", "هیدج"] },
    { "province": "سمنان", "cities": ["امیریه", "ایوانکی", "آرادان", "بسطام", "بیارجمند", "دامغان", "درجزین", "دیباج", "سرخه", "سمنان", "شاهرود", "شهمیرزاد", "کلاته خیج", "گرمسار", "مجن", "مهدی شهر", "میامی"] },
    { "province": "سیستان وبلوچستان", "cities": ["ادیمی", "اسپکه", "ایرانشهر", "بزمان", "بمپور", "بنت", "بنجار", "پیشین", "جالق", "چاه بهار", "خاش", "دوست محمد", "راسک", "زابل", "زابلی", "زاهدان", "زرآباد", "زهک", "سراوان", "سرباز", "سوران", "سیرکان", "علی اکبر", "فنوج", "قصرقند", "کنارک", "گشت", "گلمورتی", "محمدان", "محمد آباد", "محمدی", "میرجاوه", "نصرت آباد", "نگور", "نوک آباد", "نیک شهر", "هیدوج"] },
    { "province": "فارس", "cities": ["اردکان", "ارسنجان", "استهبان", "اسیر", "اشکنان", "افزر", "اقلید", "امام شهر", "اوز", "اهل", "ایج", "ایزدخواست", "آباده", "آباده طشک", "باب انار", "بالاده", "بنارویه", "بوانات", "بهمن", "بیرم", "بیضا", "جنت شهر", "جویم", "جهرم", "حاجی آباد", "حسامی", "حسن آباد", "خانه زنیان", "خاوران", "خرامه", "خشت", "خنج", "خور", "خومه زار", "داراب", "داریان", "دبیران", "دژکرد", "دوبرجی", "دوزه", "دهرم", "رامجرد", "رونیز", "زاهدشهر", "زرقان", "سده", "سروستان", "سعادت شهر", "سورمق", "سیدان", "ششده", "شهر جدید صدرا", "شهرپیر", "شیراز", "صغاد", "صفاشهر", "علامرودشت", "عمادده", "فدامی", "فراشبند", "فسا", "فیروزآباد", "قادرآباد", "قائمیه", "قطب آباد", "قطرویه", "قیر", "کارزین", "کازرون", "کامفیروز", "کره ای", "کنارتخته", "کوار", "کوهنجان", "گراش", "گله دار", "لار", "لامرد", "لپوئی", "لطیفی", "مبارک آباد", "مرودشت", "مشکان", "مصیری", "مهر", "میمند", "نوبندگان", "نوجین", "نودان", "نورآباد", "نی ریز", "وراوی", "هماشهر"] },
    { "province": "قزوین", "cities": ["ارداق", "اسفرورین", "اقبالیه", "الوند", "آبگرم", "آبیک", "آوج", "بوئین زهرا", "بیدستان", "تاکستان", "خاکعلی", "خرمدشت", "دانسفهان", "رازمیان", "سگزآباد", "سیردان", "شال", "شریفیه", "ضیاءآباد", "قزوین", "کوهین", "محمدیه", "محمودآبادنمونه", "معلم کلایه", "نرجه"] },
    { "province": "قم", "cities": ["جعفریه", "دستجرد", "سلفچگان", "قم", "قنوات", "کهک"] },
    { "province": "کردستان", "cities": ["آرمرده", "بابارشانی", "بانه", "بلبان آباد", "بوئین سفلی", "بیجار", "چناره", "دزج", "دلبران", "دهگلان", "دیواندره", "زرینه", "سروآباد", "سریش آباد", "سقز", "سنندج", "شویشه", "صاحب", "قروه", "کامیاران", "کانی دینار", "کانی سور", "مریوان", "موچش", "یاسوکند"] },
    { "province": "کرمان", "cities": ["اختیارآباد", "ارزوئیه", "امین شهر", "انار", "اندوهجرد", "باغین", "بافت", "بردسیر", "بروات", "بزنجان", "بم", "بهرمان", "پاریز", "جبالبارز", "جوپار", "جوزم", "جیرفت", "چترود", "خاتون آباد", "خانوک", "خورسند", "درب بهشت", "دوساری", "دهج", "رابر", "راور", "راین", "رفسنجان", "رودبار", "ریحان شهر", "زرند", "زنگی آباد", "زیدآباد", "سرچشمه", "سیرجان", "شهداد", "شهربابک", "صفائیه", "عنبرآباد", "فاریاب", "فهرج", "قلعه گنج", "کاظم آباد", "کرمان", "کشکوئیه", "کوهبنان", "کهنوج", "کیانشهر", "گلباف", "گلزار", "لاله زار", "ماهان", "محمد آباد", "محی آباد", "مردهک", "منوجان", "نجف شهر", "نرماشیر", "نظام شهر", "نگار", "نودژ", "هجدک", "هماشهر", "یزدان شهر"] },
    { "province": "کرمانشاه", "cities": ["ازگله", "اسلام آبادغرب", "باینگان", "بیستون", "پاوه", "تازه آباد", "جوانرود", "حمیل", "رباط", "روانسر", "سرپل ذهاب", "سرمست", "سطر", "سنقر", "سومار", "شاهو", "صحنه", "قصرشیرین", "کرمانشاه", "کرندغرب", "کنگاور", "کوزران", "گهواره", "گیلانغرب", "میان راهان", "نودشه", "نوسود", "هرسین", "هلشی"] },
    { "province": "کهگیلویه وبویراحمد", "cities": ["باشت", "پاتاوه", "چرام", "چیتاب", "دوگنبدان", "دهدشت", "دیشموک", "سوق", "سی سخت", "قلعه رئیسی", "گراب سفلی", "لنده", "لیکک", "مادوان", "مارگون", "یاسوج"] },
    { "province": "گلستان", "cities": ["انبارآلوم", "اینچه برون", "آزادشهر", "آق قلا", "بندرگز", "ترکمن", "جلین", "خان ببین", "دلند", "رامیان", "سرخنکلاته", "سیمین شهر", "علی آباد", "فاضل آباد", "کردکوی", "کلاله", "گالیکش", "گرگان", "گمیش تپه", "گنبد کاووس", "مراوه تپه", "مینودشت", "نگین شهر", "نوده خاندوز", "نوکنده"] },
    { "province": "گیلان", "cities": ["احمدسرگوراب", "اسالم", "اطاقور", "املش", "آستارا", "آستانه اشرفیه", "بازارجمعه", "بره سر", "بندرانزلی", "پره سر", "توتکابن", "جیرنده", "چابکسر", "چاف وچمخاله", "چوبر", "حویق", "خشکبیجار", "خمام", "دیلمان", "رانکوه", "رحیم آباد", "رستم آباد", "رشت", "رضوانشهر", "رودبار", "رودبنه", "رودسر", "سنگر", "سیاهکل", "شفت", "شلمان", "صومعه سرا", "فومن", "کلاچای", "کوچصفهان", "کومله", "کیاشهر", "گوراب زرمیخ", "لاهیجان", "لشت نشاء", "لنگرود", "لوشان", "لولمان", "لوندویل", "لیسار", "ماسال", "ماسوله", "مرجقل", "منجیل", "واجارگاه", "هشتپر"] },
    { "province": "لرستان", "cities": ["ازنا", "اشترینان", "الشتر", "الیگودرز", "بروجرد", "پلدختر", "چالانچولان", "چغلوندی", "چقابل", "خرم آباد", "درب گنبد", "دورود", "زاغه", "سپیددشت", "سراب دوره", "شول آباد", "فیروز آباد", "کونانی", "کوهدشت", "گراب", "معمولان", "مؤمن آباد", "نور آباد", "ویسیان", "هفت چشمه"] },
    { "province": "مازندران", "cities": ["امیرکلا", "ایزدشهر", "آلاشت", "آمل", "بابل", "بابلسر", "بلده", "بهشهر", "بهنمیر", "پل سفید", "پول", "تنکابن", "جویبار", "چالوس", "چمستان", "خرم آباد", "خلیل شهر", "خوش رودپی", "دابودشت", "رامسر", "رستمکلا", "رویان", "رینه", "زرگر محله", "زیرآب", "ساری", "سرخرود", "سلمان شهر", "سورک", "شیرگاه", "شیرود", "عباس آباد", "فریدونکنار", "فریم", "قائم شهر", "کتالم وسادات شهر", "کلارآباد", "کلاردشت", "کله بست", "کوهی خیل", "کیاسر", "کیاکلا", "گتاب", "گزنک", "گلوگاه", "محمود آباد", "مرزن آباد", "مرزیکلا", "نشتارود", "نکا", "نور", "نوشهر"] },
    { "province": "مرکزی", "cities": ["اراک", "آستانه", "آشتیان", "پرندک", "تفرش", "توره", "جاورسیان", "خشکرود", "خمین", "خنداب", "داودآباد", "دلیجان", "رازقان", "زاویه", "ساروق", "ساوه", "سنجان", "شازند", "شهرجدیدمهاجران", "غرق آباد", "فرمهین", "قورچی باشی", "کرهرود", "کمیجان", "مأمونیه", "محلات", "میلاجرد", "نراق", "نوبران", "نیمور", "هندودر"] },
    { "province": "هرمزگان", "cities": ["ابوموسی", "بستک", "بندرجاسک", "بندرچارک", "بندرعباس", "بندرلنگه", "بیکاه", "پارسیان", "تخت", "جناح", "حاجی آباد", "خمیر", "درگهان", "دهبارز", "رویدر", "زیارتعلی", "سردشت بشاگرد", "سرگز", "سندرک", "سوزا", "سیریک", "فارغان", "فین", "قشم", "قلعه قاضی", "کنگ", "کوشکنار", "کیش", "گوهران", "میناب", "هرمز", "هشتبندی"] },
    { "province": "همدان", "cities": ["ازندریان", "اسدآباد", "برزول", "بهار", "تویسرکان", "جورقان", "جوکار", "دمق", "رزن", "زنگنه", "سامن", "سرکان", "شیرین سو", "صالح آباد", "فامنین", "فرسفج", "فیروزان", "قروه در جزین", "قهاوند", "کبودرآهنگ", "گل تپه", "گیان", "لالجین", "مریانج", "ملایر", "نهاوند", "همدان"] },
    { "province": "یزد", "cities": ["ابرکوه", "احمدآباد", "اردکان", "اشکذر", "بافق", "بفروئیه", "بهاباد", "تفت", "حمیدیا", "خضرآباد", "دیهوک", "زارچ", "شاهدیه", "طبس", "عشق آباد", "عقدا", "مروست", "مهردشت", "مهریز", "میبد", "ندوشن", "نیر", "هرات", "یزد"] }
];

const PERSON_TYPE_MAP = {
    'حقیقی': '1',
    'حقوقی': '2',
    'مشارکت مدنی': '3',
    'اتباع غیر ایرانی': '4',
};
const PERSON_TYPES = Object.keys(PERSON_TYPE_MAP);

const { PROVINCE_MAP, ALL_PROVINCE_NAMES, ALL_CITY_OPTIONS } = (() => {
    let provinceId = 0;
    const pMap = {};
    const provinceNames = [];
    const cityOptions = {};

    PROVINCE_CITY_DATA.forEach(p => {
        provinceId++;
        const pId = String(provinceId);
        pMap[p.province] = { id: pId, cities: {} };
        provinceNames.push(p.province);
        cityOptions[p.province] = [];

        let cityId = 0;
        p.cities.forEach(c => {
            cityId++;
            const cId = String(provinceId * 1000 + cityId);
            pMap[p.province].cities[c] = cId;
            cityOptions[p.province].push({ name: c, id: cId });
        });
    });

    return { PROVINCE_MAP: pMap, ALL_PROVINCE_NAMES: provinceNames, ALL_CITY_OPTIONS: cityOptions };
})();

function AddBuyerModal({ show, handleClose, handleAddBuyer }) {

    const initialFormData = {
        personType: 'حقیقی',
        firstName: '',
        lastName: '',
        companyName: '',
        nationalCode: '',
        economicCode: '',
        branchCode: '',
        branchName: '',
        province: '',
        city: '',
        street: '',
        plaque: '',
        postalCode: '',
        tel: '',
        mobile: '',
    };

    const [formData, setFormData] = useState(initialFormData);
    const [cities, setCities] = useState([]);
    const [provinces, setProvinces] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [toast, setToast] = useState({ show: false, message: '' });
    const [modalError, setModalError] = useState('');

    useEffect(() => {
        if (toast.show) {
            const timer = setTimeout(() => setToast({ ...toast, show: false }), 5000);
            return () => clearTimeout(timer);
        }
    }, [toast.show]);

    useEffect(() => {
        if (show) {
            setModalError('');
            const fetchProvinces = async () => {
                try {
                    const provData = await apiClient('/internal-network/api/location/?type=province', { method: 'GET' });
                    if (provData && provData.provinces) {
                        setProvinces(provData.provinces);
                    } else if (Array.isArray(provData)) {
                        setProvinces(provData);
                    }
                } catch (err) {
                    console.error('Error fetching provinces', err);
                }
            };
            fetchProvinces();
        }
    }, [show]);

    useEffect(() => {
        if (formData.province) {
            const fetchCities = async () => {
                try {
                    const cityData = await apiClient(`/account/api/cities/?province=${formData.province}`, { method: 'GET' });
                    if (cityData && cityData.cities) {
                        setCities(cityData.cities);
                    } else if (Array.isArray(cityData)) {
                        setCities(cityData);
                    } else {
                        setCities([]);
                    }
                } catch (err) {
                    console.error('Error fetching cities', err);
                    setCities([]);
                }
            };
            fetchCities();
        } else {
            setCities([]);
        }
    }, [formData.province]);

    const showToast = (message) => {
        setToast({ show: true, message });
    };

    const isHaghighi = formData.personType === 'حقیقی';

    const requiredFields = useMemo(() => {
        const base = ['personType', 'nationalCode', 'province', 'city'];
        if (isHaghighi) {
            return [...base, 'firstName', 'lastName'];
        }
        return [...base, 'companyName'];
    }, [isHaghighi]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'province') {
            setFormData(prev => ({ ...prev, [name]: value, city: '' }));
        } else if (name === 'personType') {
            setFormData({ ...initialFormData, personType: value });
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async () => {
        const missingFields = requiredFields.filter(field => !formData[field]);
        if (missingFields.length > 0) {
            const fieldNamesMap = {
                personType: 'نوع شخص', firstName: 'نام', lastName: 'نام خانوادگی',
                nationalCode: isHaghighi ? 'کد ملی' : 'شناسه ملی',
                companyName: 'نام شرکت / سازمان', province: 'استان', city: 'شهر'
            };
            const missingNames = missingFields.map(field => fieldNamesMap[field] || field);
            showToast(`لطفاً فیلدهای اجباری زیر را تکمیل کنید: ${missingNames.join(', ')}`);
            return;
        }

        const selectedProvince = provinces.find(p => String(p.id || p.code) === String(formData.province));
        const selectedCity = cities.find(c => String(c.id || c.code) === String(formData.city));

        if (!selectedProvince || !selectedCity) {
            showToast('خطا در یافتن کد استان یا شهر. لطفاً مجدداً انتخاب کنید.');
            return;
        }

        const selectedProvinceId = selectedProvince.id || selectedProvince.code;
        const selectedCityId = selectedCity.id || selectedCity.code;

        setIsLoading(true);

        try {
            const existingPersons = await apiClient('/user-preferences/api/user-person/');
            const duplicateCheck = Array.isArray(existingPersons) ? existingPersons.find(u => {
                if (isHaghighi) {
                    return String(u.personId || '').trim() === String(formData.nationalCode || '').trim() && 
                           String(formData.nationalCode || '').trim() !== '';
                } else {
                    const hasNationalCodeMatch = String(u.personId || '').trim() === String(formData.nationalCode || '').trim() && 
                                                 String(formData.nationalCode || '').trim() !== '';
                    const hasEconomicCodeMatch = String(u.personEconomicNum || '').trim() === String(formData.nationalCode || '').trim() && 
                                                 String(formData.nationalCode || '').trim() !== '';
                    return hasNationalCodeMatch || hasEconomicCodeMatch;
                }
            }) : null;

            if (duplicateCheck) {
                setModalError('شخصی با این شناسه ملی، کد ملی یا کد اقتصادی قبلاً ثبت شده است');
                setIsLoading(false);
                return;
            }

            const buyerName = isHaghighi ? `${formData.firstName} ${formData.lastName}` : formData.companyName;

            const payload = {
                name: formData.firstName || null,
                lastName: formData.lastName || null,
                personType: PERSON_TYPE_MAP[formData.personType],
                personId: formData.nationalCode ? String(formData.nationalCode) : null,
                personPostalCode: formData.postalCode ? String(formData.postalCode) : null,
                personEconomicNum: isHaghighi ? null : (formData.nationalCode ? String(formData.nationalCode) : null),
                companyName: isHaghighi ? null : formData.companyName,
                registrationNum: isHaghighi ? null : (formData.nationalCode ? String(formData.nationalCode) : null),
                province: selectedProvinceId,
                city: selectedCityId,
                street: formData.street || null,
                pelak: formData.plaque || null,
                phoneNum: formData.tel || null,
                mobileNum: formData.mobile || null,
                branchNum: formData.branchCode ? String(formData.branchCode) : null,
                branchName: formData.branchName || null,
            };

            const response = await apiClient('/user-preferences/api/user-person/', {
                method: 'POST',
                data: payload
            });

            handleAddBuyer({
                name: buyerName,
                id: response.data?.id || response.id || `new-${Date.now()}`,
                nationalCode: payload.personId,
            });

            setFormData(initialFormData);
            handleClose();
        } catch (error) {
            if (error.message && (error.message.includes('duplicate') || error.message.includes('تکراری'))) {
                setModalError('شخصی با این شناسه ملی، کد ملی یا کد اقتصادی قبلاً ثبت شده است');
            } else {
                showToast(`خطا در ثبت شخص: ${error.message || 'خطای ناشناس'}`);
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered size="lg" scrollable>
            <Modal.Header closeButton>
                <Modal.Title>افزودن شخص جدید ({formData.personType})</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {modalError ? (
                    <div className="alert alert-danger mb-3" role="alert">
                        {modalError}
                    </div>
                ) : null}
                <div className="row">

                    <div className="col-12 mb-4">
                        <label className="form-label">نوع شخص <span className="text-danger">*</span></label>
                        <select className="form-select" name="personType" value={formData.personType} onChange={handleChange}>
                            {PERSON_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                        </select>
                    </div>

                    {isHaghighi ? (
                        <>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">نام <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="firstName" value={formData.firstName} onChange={handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">نام خانوادگی <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" name="lastName" value={formData.lastName} onChange={handleChange} />
                            </div>
                        </>
                    ) : (
                        <div className="col-md-4 mb-3">
                            <label className="form-label">نام شرکت / سازمان <span className="text-danger">*</span></label>
                            <input type="text" className="form-control" name="companyName" value={formData.companyName} onChange={handleChange} />
                        </div>
                    )}

                    <div className="col-md-4 mb-3">
                        <label className="form-label">
                            {isHaghighi ? 'کد ملی' : 'شناسه ملی / شناسه اقتصادی'} <span className="text-danger">*</span>
                        </label>
                        <input type="text" className="form-control" name="nationalCode" value={formData.nationalCode} onChange={handleChange} />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">کد شعبه</label>
                        <input type="text" className="form-control" name="branchCode" value={formData.branchCode} onChange={handleChange} />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">نام شعبه</label>
                        <input type="text" className="form-control" name="branchName" value={formData.branchName} onChange={handleChange} />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">تلفن ثابت</label>
                        <input type="text" className="form-control" name="tel" value={formData.tel} onChange={handleChange} placeholder="مثال: 021xxxxxxx" />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">شماره همراه</label>
                        <input type="text" className="form-control" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="09xxxxxxxxx" />
                    </div>

                    <div className="col-12"><hr className="my-2" /></div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">استان <span className="text-danger">*</span></label>
                        <select className="form-select" name="province" value={formData.province} onChange={handleChange}>
                            <option value="">استان خود را انتخاب کنید</option>
                            {provinces.length > 0 ? provinces.map(p => (
                                <option key={p.id || p.code} value={p.id || p.code}>{p.name}</option>
                            )) : <option value="">در حال بارگذاری...</option>}
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">شهر <span className="text-danger">*</span></label>
                        <select className="form-select" name="city" value={formData.city} onChange={handleChange} disabled={!formData.province}>
                            <option value="">شهر خود را انتخاب کنید</option>
                            {cities.length > 0 ? cities.map(c => (
                                <option key={c.id || c.code} value={c.id || c.code}>{c.name}</option>
                            )) : formData.province ? <option value="">در حال بارگذاری...</option> : <option value="">ابتدا استان را انتخاب کنید</option>}
                        </select>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">خیابان</label>
                        <input type="text" className="form-control" name="street" value={formData.street} onChange={handleChange} />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">پلاک</label>
                        <input type="text" className="form-control" name="plaque" value={formData.plaque} onChange={handleChange} />
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">کد پستی</label>
                        <input type="text" className="form-control" name="postalCode" value={formData.postalCode} onChange={handleChange} />
                    </div>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose}>انصراف</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={isLoading}>
                    {isLoading ? 'در حال ثبت...' : 'ثبت'}
                </button>
            </Modal.Footer>
            {toast.show && (
                <div aria-live="polite" aria-atomic="true" className="position-fixed w-100 p-3" style={{ zIndex: 10050, top: 0, right: 0 }}>
                    <div className="toast-container position-absolute p-3" id="toastPlacement" style={{ top: 0, left: 0 }}>
                        <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                            <div className="toast-header" style={{ direction: 'rtl' }}>
                                <img src="/assets/images/redesigned.png" className="rounded ms-2" alt="..." width="20" />
                                <strong className="me-auto ms-2">پیام سیستم</strong>
                                <button type="button" className="btn-close" onClick={() => setToast({ ...toast, show: false })}></button>
                            </div>
                            <div className="toast-body">
                                {toast.message}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
}

export default AddBuyerModal;